import { render, staticRenderFns } from "./MovingTouch.vue?vue&type=template&id=d2fde910&scoped=true&"
var script = {}
import style0 from "./MovingTouch.vue?vue&type=style&index=0&id=d2fde910&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fde910",
  null
  
)

export default component.exports